import { algoliaSearch } from './algoliaInstantSearch/instantSearch';
import startAutocomplete from './algoliaAutocomplete/autocomplete';

const initAlgoliaSearch = () => {
	startAutocomplete(algoliaSearch);
};

export default initAlgoliaSearch;
